// extracted by mini-css-extract-plugin
export default {"feedbackButton":"FeedbackButton_feedbackButton__8Pxe8","icon":"FeedbackButton_icon__ucXiY","label":"FeedbackButton_label__fS0fx","visible":"FeedbackButton_visible__P-MHc"};